import { render } from "./Cod4ValetPage.vue?vue&type=template&id=c54e4a00"
import script from "./Cod4ValetPage.vue?vue&type=script&lang=js"
export * from "./Cod4ValetPage.vue?vue&type=script&lang=js"

import "./Cod4ValetPage.vue?vue&type=style&index=0&id=c54e4a00&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__